import api from "../utils/axios";

export const sendOTP = async (email) => {
  try {
    const response = await api.post("/auth/send-otp", { email });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const verifyOTP = async (email, otp) => {
  try {
    const response = await api.post("/auth/verify-otp", { email, otp });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const refreshToken = async (refreshToken) => {
  try {
    const response = await api.post("/auth/refresh-token", { refreshToken });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Resend signup OTP
export const resendSignupOTP = async (email) => {
  try {
    const response = await api.post("/auth/resend-signup-otp", { email });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Resend device verification OTP
export const resendDeviceOTP = async (email) => {
  try {
    const response = await api.post("/auth/resend-device-otp", { email });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Resend password reset OTP
export const resendPasswordOTP = async (email) => {
  try {
    const response = await api.post("/auth/resend-password-otp", { email });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getUsage = async () => {
  try {
    const response = await api.get("/auth/get-usage");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getPermissions = async () => {
  try {
    const response = await api.get("/auth/permissions");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
